import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { map, take, tap } from 'rxjs/operators';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // The expected role should be passed in the route data, e.g., { role: 'admin' }
  const expectedRole = route.data['roles'] as string[];

  return authService.user$.pipe(
    take(1),
    map(user => {
      // Allow if user is logged in AND (no role required OR user has the role)
      // Note: 'admin' should probably have access to everything, but stricter checks can be added here.
      // For now, strict equality check.
      return !!user && expectedRole.includes(user.role);
    }),
    tap(hasRole => {
      if (!hasRole) {
        // Redirect to home or unauthorized page
        router.navigate(['/']);
      }
    })
  );
};
